<template>
	<section class=" bg-main">
		<div class="py-12"></div>
		<div class="vx-row justify-center m-0">
			<div class="vx-col w-full md:w-3/4 lg:w-1/2 xl:w-1/3">
				<vx-card style="height: 100%;">
					<component 
						:is="currentComponent"
						@register="register"
						@registerMitra="registerMitra"
            @backRegister="backRegister"
					>
					</component>
				</vx-card>
			</div>
		</div>
		<div class="py-12"></div>
	</section>
</template>
<style>
	.bg-main {
		background-image: url('/assets/images/footer/bg.svg');
		background-repeat: no-repeat;
		background-size: cover;
	}
</style>
<script>
import vSelect from 'vue-select'
import RegisterForm from './components/RegisterForm.vue'
import RegisterFormMitra from './components/RegisterFormMitra.vue'

export default {
  components: {
    vSelect,
    RegisterForm,
    RegisterFormMitra
  },
  data: () => ({
    currentComponent: 'RegisterForm',
    level_id: 0,
    doubleForm: 'sahabat zx',
    dataUser: {}
  }),
  methods: {
    backRegister() {
      this.currentComponent = 'RegisterForm'
    },
    registerMitra () {
				
    },
    register (data) {

      if (data.level_key === this.doubleForm) {
        // Regis as Mitra
        this.dataUser = data
        this.currentComponent = 'RegisterFormMitra'
      } else {
        // Regis as user
        this.$vs.loading()
        data.jenis = 1
        this.$store.dispatch('auth/register', [data])
          .then(() => {
            this.$vs.loading.close()

            this.$router.push('/confirm-your-email')
          })
          .catch(e => {
            this.$vs.loading.close()

            this.showError(e, 5000)

            return false
          })
      }

				
    }
  }
}
</script>